function trimTrailingSlash(url: string) {
  return url.replace(/\/$/, '')
}

export function getLfsBaseUrl(): string {
  const url = process.env.VITE_LFS_URL
  if (typeof url !== 'string' || url.length === 0) {
    throw new Error('VITE_LFS_URL is required')
  }
  return trimTrailingSlash(url)
}

export function getAidaPortraitUrl(): string {
  return `${getLfsBaseUrl()}/studio/aida/aida-launcher.webp`
}

export function getAidaMascotModelUrl(bodyPath: string): string {
  return `${getLfsBaseUrl()}/${bodyPath}`
}
